import { render, staticRenderFns } from "./RadioTransferExt.vue?vue&type=template&id=763519b8&lang=pug"
import script from "./RadioTransferExt.vue?vue&type=script&lang=js"
export * from "./RadioTransferExt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports